import { Roles } from '@/auth/azure/Roles'
import { HoursDashboard } from '@/routes/hours/dashboard/HoursDashboard'
import { RoleRouteObject } from '@/types'
import { faClock } from '@fortawesome/free-solid-svg-icons'

export const HoursDashboardRoute = {
  path: 'dashboard',
  element: <HoursDashboard />,
  allowedRoles: [
    Roles.GlobalAdministrator,
    Roles.Administrator,
    Roles.Marketing,
    Roles.TechDeveloper,
    Roles.Sales,
    Roles.Supervisor,
  ],
  handle: {
    crumb: () => ({
      label: 'Dashboard',
      icon: faClock,
    }),
  },
} as RoleRouteObject
